<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div  class="div-query-banner"  >
          <a-form-item label="基地">
            <j-dict-select-tag  ref="baseSelectRef" :is-choose-first="true" v-model="queryParam.baseNo" placeholder="请选择基地"   dictCode="bus_inspection_general_base,base,base_no,status = '1'"  ></j-dict-select-tag>
          </a-form-item>
          <a-form-item label="分组名称">
            <j-input   v-model="queryParam.groupName" placeholder="请输入分组名称"   ></j-input>
          </a-form-item>
          <a-button  class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
          <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('巡检分组配置表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :rowClassName="rowClassName"
        :customRow="customRow"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click.stop="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a @click.stop class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <workshop-group-list-modal ref="modalForm" @ok="modalFormOk"></workshop-group-list-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WorkshopGroupListModal from '../modules/WorkshopGroupListModal.vue'
  import JInput from '@/components/jeecg/JInput.vue'

  export default {
    name: "BusInspectionGroupList",
    mixins:[JeecgListMixin],
    components: {
      WorkshopGroupListModal,JInput
    },
    data () {
      return {
        description: '巡检分组配置表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'基地',
            align:"center",
            dataIndex: 'base'
          },
          {
            title:'组名',
            align:"center",
            dataIndex: 'groupName'
          },
          {
            title:'是否启用',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/general/group/busInspectionGroup/list",
          delete: "/general/group/busInspectionGroup/delete",
          deleteBatch: "/general/group/busInspectionGroup/deleteBatch",
          exportXlsUrl: "/general/group/busInspectionGroup/exportXls",
          importExcelUrl: "general/group/busInspectionGroup/importExcel",
        },
        dictOptions:{},
        chooseRowId:"",
        chooseRow:{},
        customRow:(record)=>{
          return {
            on:{
              click:(event)=>{
                this.chooseRow=record;
                this.chooseRowId=record.id;
              }
            }
          }
        }
        
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      rowClassName(record){
        if(record.id==this.chooseRowId){
          return "row-choose-bgblue";
        }
      },
      handleAdd: function () {
        let base=this.$refs.baseSelectRef.getSelectLabels();
        let record={
          baseNo:this.queryParam.baseNo,
          base
        }
        this.$refs.modalForm.add(record);
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
      },
      initDictConfig(){
      }
    },
    watch:{
      chooseRowId(newVal){
        this.$emit("chooseGroup",this.chooseRow)
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      width:200px
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
  /deep/.row-choose-bgblue{
    background: #e6f7ff !important;
  }
</style>